<ng-container *ngIf="!isTransferOutInProgress()">
	<ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
		<ion-refresher-content pulling-icon="chevron-down-circle-outline"></ion-refresher-content>
	  </ion-refresher>
	<ion-grid class="ion-no-padding">
		<ion-row>
			<ion-col size="10" class="ion-no-padding">
			</ion-col>
			<ion-col size="2" class="ion-no-padding">
				<ion-button class="ion-no-padding reload"  fill="clear" (click)="refreshPage()">
					<ion-icon slot="icon-only" name="reload-outline" ></ion-icon>
				</ion-button>
			</ion-col>
		</ion-row>
	</ion-grid>
	<app-item-picker (itemSelected)="onEnvironmentSelected($event)" [input]="environmentPickerModel"></app-item-picker>
	<app-item-picker
		(itemSelected)="onBusinessUnitSelected($event)"
		[input]="businessUnitsPickerModel"
	></app-item-picker>
	<app-item-picker
		(itemSelected)="onDhlLoggingStyleSelected($event)"
		[input]="dhlLoggingStylePickerModel"
	></app-item-picker>
	<app-item-picker
		(itemSelected)="onSstnLoggingStyleSelected($event)"
		[input]="sstnLoggingStylePickerModel"
	></app-item-picker>
	<app-item-picker
		*ngIf="connectionType === connectionTypeEnum.includeOptionsAndDescriptions"
		(itemSelected)="onDescriptionSelected($event)"
		[input]="descriptionsPickerModel"
	></app-item-picker>

	<div class="submit">
		<button
			type="submit"
			[ngClass]="{ disabled: !readyForSubmit }"
			[disabled]="!readyForSubmit"
			(click)="onSubmit()"
		>
			{{ 'connectionsModal.form.options.submit' | translate }}
		</button>
	</div>
</ng-container>

<div class="progress-holder" *ngIf="isTransferOutInProgress()">
	<div class="progress-message">{{ 'importPage.transferOutOptions.progressMessage' | translate }}</div>
	<div class="progress m-t-30">
		<div class="progress-bar running-progress-bar" role="progressbar"></div>
	</div>
</div>
